import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import styles from './index.module.scss'
import { getStorageInfo } from '@/utils/auth'
import { getCurrentCombo, getPayDiscountInfo } from '@/service'
import { getCookie, setCookie, removeCookie, getNowFormatDate } from './utils'
import { getDeviceId } from '@/utils/auth'

import DownTime from './DownTime'
import buriedSdk from '@/utils/zz-buried/index'

const DiscountDrawer = () => {
  const caKey = `discount-show-date-${getStorageInfo()?.userId}` // 该用户今日是否已经弹出
  const drawerVisibleKey = `drawer-visible-${getStorageInfo()?.userId}` // 该用户今日是否弹出大弹框  也代表在移动端是否开始倒计时
  const [isAuthorized, setAuthorized] = useState(false)
  // const [caKey, setCaKey] = useState('discount-show-date')

  const [isCloseAll, setIsCloseAll] = useState(false)

  const [visible, setVisible] = useState(false)
  const [miniVisible, setMiniVisible] = useState(false)
  const [mostDisCountInfo, setMostDisCountInfo] = useState({
    actualAmount: 0,
    ruleDesc: '',
    marketingId: '',
    cycleUnit: 'm'
  })

  let timer = useRef<any>(null)

  const handleToUrl = (url: string) => {
    window.location.href = process.env.NEXT_PUBLIC_MOBILE_URL + url
  }
  useEffect(() => {
    console.log('isCloseAll~~ ', isCloseAll)

    if (isCloseAll) {
      if (visible !== false) {
        setVisible(false)
      }
      if (miniVisible !== false) {
        setMiniVisible(false)
      }
      // stopCheckActivityShow()
      return
    }
    if (visible) {
      setTimeout(() => {
        setVisible(false)
        setMiniVisible(true)
      }, 5000)
    }
  }, [visible, isCloseAll])

    // 首次弹出弹框提示
    useEffect(() => {
        if (visible && !miniVisible && mostDisCountInfo.marketingId) {
            buriedSdk &&
                buriedSdk?.buried({
                    event: "显示首月优惠弹窗",
                    scene: "命中首月优惠活动",
                    page_name: "全局",
                    page_url: document?.URL,
                    user_id: getStorageInfo()?.userId,
                    json_str: JSON.stringify({
                        marketing_id: mostDisCountInfo.marketingId,
                    }),
                    URL: process.env.publicApiDomain,
                });
            setCookie(drawerVisibleKey, getNowFormatDate());
        }
    }, [visible, miniVisible, mostDisCountInfo.marketingId]);

  const getAmount = (type = 'm') => {
    const fixedNumber = (num, digit = 2) => {
      if (typeof num !== 'number') {
        return num
      }
      return parseFloat(num.toFixed(digit))
    }
    if (type === 'm') {
      return mostDisCountInfo.actualAmount
    }
    if (mostDisCountInfo.cycleUnit === 'm') {
      return mostDisCountInfo.actualAmount
    }
    return fixedNumber(mostDisCountInfo.actualAmount / 12)
  }

    const handleJump = (type) => {
        closeAll(false);
        buriedSdk &&
            buriedSdk?.buried({
                event: "按钮点击",
                scene: `首月优惠活动入口-${
                    type === "drawer" ? "弹窗" : "悬浮"
                }`,
                page_name: "全局",
                page_url: document?.URL,
                // referer: '',
                user_id: getStorageInfo()?.userId,
                json_str: JSON.stringify({
                    marketing_id: mostDisCountInfo.marketingId,
                }),
                URL: process.env.publicApiDomain,
            });

    handleToUrl('/checkout')
  }
  const handleClose = (e) => {
    e.stopPropagation()
    setVisible(false)
    setMiniVisible(true)
  }
  const resetDownTime = () => {
    const drawerDownTimeCaKey = getCookie(drawerVisibleKey)
    const nowDate = getNowFormatDate()
    console.log('drawerDownTimeCaKey~~ ', drawerDownTimeCaKey)
    //今日未开始倒计时
    if (!drawerDownTimeCaKey || drawerDownTimeCaKey !== nowDate) {
      console.log('今日未开始倒计时~~ ')
      removeDownTime()
    }

    if (
      +getCookie('countDown') > 10 ||
      (+getCookie('countDown') === 0 && +getCookie('countDownSeconds') === 0)
    ) {
      removeDownTime()
    }
  }
  const removeDownTime = () => {
    removeCookie('countDown')
    removeCookie('countDownSeconds')
  }
  const handleMiniClose = (e) => {
    e.stopPropagation()
    removeDownTime()
    closeAll()
  }

  const stopCheckActivityShow = () => {
    clearInterval(timer.current)
    timer.current = null
  }

  const getMostDiscount = (discountInfo) => {
    let _mostDisCountInfo = {}
    if (discountInfo && discountInfo?.length !== 0) {
      _mostDisCountInfo = discountInfo.sort((a, b) => {
        return a.actualAmount - b.actualAmount
      })[0]
    } else {
      _mostDisCountInfo = {}
    }
    setMostDisCountInfo(_mostDisCountInfo as any)
  }
  let a = 0

  const getActivityShow = async () => {
    const discountShowDate = getCookie(caKey)
    console.log('key~~ ', caKey, discountShowDate)
    if (discountShowDate) {
      const nowDate = getNowFormatDate()
      //相同日期就不在弹出了。
      if (nowDate === discountShowDate) {
        stopCheckActivityShow()
        return
      }
    }
    // a ++

    try {
      const res = await getPayDiscountInfo(14, 5, getDeviceId())
      const drawerVisibleStorage = getCookie(drawerVisibleKey)
      // console.log('drawerVisibleStorage~~ ', drawerVisibleStorage)

      if (res.code === 0) {
        if (res.data && res.data?.length) {
          getMostDiscount(res.data)
          if (!miniVisible && !visible) {
            if (
              (drawerVisibleStorage && drawerVisibleStorage !== getNowFormatDate()) ||
              !drawerVisibleStorage
            ) {
              setVisible(true)
            } else {
              setMiniVisible(true)
            }
          }
        } else {
          console.log('活动结束关闭所有弹~~')
          //活动结束关闭所有弹框  但是不关闭轮询
          setMiniVisible(false)
          setVisible(false)
          setIsCloseAll(true)
        }
      } else {
        setVisible(false)
        setMiniVisible(false)
        stopCheckActivityShow()
      }
    } catch (error) {
      stopCheckActivityShow()
    }
  }

  const checkActivityShow = async () => {
    try {
      const res = await getCurrentCombo() // 获取购买套餐
      //没登录或者购买了套餐就不配
      const isBuy = !!(res?.data && res?.data?.[0]?.id)

      if (!isBuy) {
        getActivityShow()
        timer.current = setInterval(() => {
          // timer.current += 1
          // console.log('timer.current~~ ', timer.current)
          getActivityShow()
        }, 8000)
      } else {
        stopCheckActivityShow()
      }
    } catch (error) {
      console.log('error~~ ', error)
    }
  }

  //关闭所有弹框
  const closeAll = (isSet = true) => {
    setIsCloseAll(true)
    //是否当天结束
    if (isSet) {
      setCookie(caKey, getNowFormatDate())
    }

    stopCheckActivityShow()
    setVisible(false)
    setMiniVisible(false)
  }

  useEffect(() => {
    const isAuth = !!getCookie('authorized-token')

    if (isAuth) {
      setAuthorized(isAuth)
      const key = `discount-show-date-${getStorageInfo()?.userId}`
      const discountShowDate = getCookie(key)
      console.log('discountShowDate~~', discountShowDate)
      console.log(getNowFormatDate())

      if (discountShowDate) {
        const nowDate = getNowFormatDate()
        //相同日期就不在弹出了。
        if (nowDate === discountShowDate) {
          stopCheckActivityShow()
          return
        } else {
          console.log('重置倒计时时间~~~')

          //重置倒计时时间
          removeCookie(key)

          resetDownTime()
        }
      } else {
        console.log('没有日期')
        resetDownTime()
      }

      checkActivityShow()
    }
  }, [])

  return (
    <div>
      <div
        className={[styles['discount-drawer'], ' animated bounceInDown'].join('')}
        style={{ display: visible && !miniVisible ? '' : 'none' }}
        onClick={() => handleJump('drawer')}
      >
        <div className={styles['discount-drawer-content']}>
          <div className={styles['title']}> Big Sale For You </div>
          <div className="flex items-center mr-[25px]">
            <div className={styles['desc']}>
              {mostDisCountInfo.cycleUnit === 'm' ? 'First-month membership' : 'Monthly Payments'}
            </div>
            <div className={styles['price']}> ${getAmount('y')} </div>

            <div className={styles['desc']}>Only</div>
          </div>
          <button className={styles['btn']}>SUBSCRIBE NOW</button>
          {mostDisCountInfo.ruleDesc ? (
            <div className={styles['discount-star']}>
              <div className={styles['discount-star-content']}>
                <div className={styles['discount-star-content-text']}>
                  {mostDisCountInfo.ruleDesc}% OFF
                </div>
              </div>
            </div>
          ) : null}
          <div className={styles.close} onClick={handleClose} />
        </div>
      </div>
      <div
        className={[styles['discount-drawer-mini'], ' animated bounceInRight'].join('')}
        style={{ display: miniVisible && !isCloseAll ? '' : 'none' }}
        onClick={() => handleJump('min-drawer')}
      >
        <div className="relative">
          <div className={styles.close} onClick={handleMiniClose} />
          <div onClick={() => handleJump('min-drawer')}>
            <div className={styles.price}> ${getAmount()}</div>
            <div className={styles.desc}>
              for 1 {mostDisCountInfo.cycleUnit === 'm' ? 'month' : 'year'}
            </div>
            <div className="mt-[10px]">{miniVisible ? <DownTime close={closeAll} /> : null}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DiscountDrawer
